import { useEffect, useMemo, useState } from "react"
import { useFilter } from "../../../context/FIlterContext";
import { Urls } from "../../../services/Urls";
import services from "../../../services/services";
import _ from "underscore";

export const useTaskReport = () => {
    const { projectFilter, setProjectFilter } = useFilter();
    const [reportData, setReportData] = useState({});
    const [loader, setLoader] = useState(false);
    const [filter, setFilter] = useState({
        month: new Date(),
        isChange: false
    });

    const colorMap = [
        { key: "task_carried", name: "Carried", color: "#0d6efd" },
        { key: "task_backlog", name: "Backlog", color: "#ffc107" },
        { key: "task_done", name: "Done", color: "green" },
        { key: "task_forwarded", name: "Forwarded", color: "red" }
    ];
    useEffect(() => {
        if (projectFilter?.apiCall) {
            getReportSummaryData();
        }
    }, [projectFilter?.apiCall]);

    const changeMonth = (increment) => {
        let newMonth = new Date(filter.month);
        newMonth.setMonth(newMonth.getMonth() + increment);
        setFilter({ month: newMonth, isChange: true });
        getReportSummaryData(newMonth);
    };

    const getReportSummaryData = async (month) => {

        try {
            setLoader(true)
            const payload = {
                "client_id": projectFilter?.client_id?.client_id || 0,
                "project_ids": _.pluck(projectFilter?.project_ids, 'project_id')?.toString(),
                "lead_user_code": projectFilter?.lead_user_code?.user_code || 0,
                "request_user_code": projectFilter?.request_user_code || 0,
                "project_module_ids": _.pluck(projectFilter?.project_module_ids, 'option_id')?.toString(),
                "feature_ids": _.pluck(projectFilter.feature_ids, 'issue_id')?.toString(),
                "issue_key": projectFilter?.issue_id,
                "month": month ? new Date(month).getMonth() + 1 : new Date(filter?.month).getMonth()
            }
            const res = await services.getInvokeRemote('POST', Urls('GETPROJECTREPORTSUMMARY'), payload)
            if (res?.status === 200) {
                const data = res?.body?.data?.project_report_summary?.[0]
                const arr = colorMap.map(({ key, name, color }) => ({
                    name,
                    value: data[key] || 0,
                    color
                }));
                setReportData(arr)
                setProjectFilter((prev) => ({ ...prev, apiCall: false }))
                setFilter((prev) => ({ ...prev, isChange: false }))
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            setProjectFilter((prev) => ({ ...prev, apiCall: false }))
            console.error('Error :', error);
        }
    }
    return useMemo(() => ({
        reportData, loader, colorMap, filter, setFilter, getReportSummaryData, changeMonth
    }), [reportData, loader, colorMap, filter, setFilter, getReportSummaryData, changeMonth])
}